import { render, staticRenderFns } from "./InternalBlogCard.vue?vue&type=template&id=b3517ec0&scoped=true"
import script from "./InternalBlogCard.vue?vue&type=script&lang=ts"
export * from "./InternalBlogCard.vue?vue&type=script&lang=ts"
import style0 from "./InternalBlogCard.vue?vue&type=style&index=0&id=b3517ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3517ec0",
  null
  
)

export default component.exports